import React from 'react'
import styled from 'styled-components'
import {Button, Icon, Dialog, Loading} from 'startlibs/lib/components'
import {Form, withForm, Errors, TextInput} from 'startlibs/lib/form'
import {withRouter} from 'react-router'
import {InfoBox} from '../checkout/CheckoutComponents'
import {getResource} from '../lib'
import {getFetcher, formFetch} from 'startlibs'
import {withToggles, fetchConnect, withRouteTo} from 'startlibs/lib/hocs'
import {Timer} from 'report-components/src/components/timer'
import {normalizeSubscription} from '../lib'
import {LoadingUser} from '../App'
import {responseFailure} from '../lib/validation'
import {logout, setNotifications} from '../reducers'
import {AJAX_ERROR,postFetcher} from 'startlibs'

const ConfirmDeletionPage = styled.div`
  h1 {
    display: flex;
    align-items: center;
    ${Icon} {
      font-size: 32px;
      color: rgba(0,0,0,0.3);
      margin-right: .5rem;
    }
  }
  h3 {
    color: rgba(0,0,0,0.5);
    font-size: 16px;
    margin-top: 2rem;
  }
  ${InfoBox} {
    margin-top: 1rem;
    margin-bottom: 0;
  }
  &.content.edit-profile .card.account-card {
    margin-bottom: 1rem;
  }
  .account-card {
    padding: 2rem;
    display: flex;
    flex-wrap: wrap;
    .user-avatar {
      width: 9rem;
      height: 9rem;
      border-radius: 5px;
      background: rgba(0,0,0,0.1);
      background: url('/public/user-avatar.png');
      background-size: cover;
      margin-right: 1rem;
    }
    .account-details {
      color: rgba(0,0,0,0.6);
      h4 {
        font-size: 14px;
        margin-bottom: 0;
      }
      flex-grow: 1;
      ul {
        list-style-type: disc;
        padding-left: 1.5rem;
      }
      .help-text {
        font-size: 12px;
        line-height: 1.2;
        color: rgba(0,0,0,0.5);
        display: block;
        margin-top: .75rem;
      }
    }
    .actions {
      width: 196px;
      margin-left: 10px;
      position: relative;
      .forgot-pass {
        position: absolute;
        top: 1px;
        right: 0;
        color: rgba(0,0,0,0.4);
      }
      ${Button} {
        width: 100%;
      }
    }
    @media (max-width: 670px) {
      .user-avatar {
        display: none;
      }
    }
    @media (max-width: 550px) {
      .actions {
        width: 100%;
        margin-top: 1rem;
        margin-left: 0;
      }
    }
  }
`

const LoadingEmail = styled.div`
  text-align: center;
  display: flex;
  padding: 3.5rem 2rem;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.1);
  border-radius: 5px;
  ${Loading} {
    margin-right: 1rem;
  }
`

@withForm(formFetch)
@withRouter
@withRouteTo
@fetchConnect(({user}) => ({user}), {setNotifications, logout}, 'stripe')
@withToggles('isRouting', 'sendingResetPassword', 'resetPasswordDialog')
export class ConfirmDeleteAccount extends React.PureComponent {
  state = {}

  onFailure = responseFailure(this.props.form,
    ({status,detail}) =>
      (detail === "Bad credentials" && {'password':['Invalid password']}) ||
      ((status === 403 || status === 404 ) && {'': ['This deletion URL is not valid. Try requesting for deletion again from account settings.']}) ||
      (status === 409 && {'': ['This deletion link has expired. Confirm deletion links expire in 1h for security reasons. You can request for deletion again from account settings.']}) ||
      ({'': [AJAX_ERROR]})
  )

  getAvatarBackground = () => ({backgroundImage: 'url("' + getResource(this.props.user.picture || '/public/user-avatar.png') + '")'})

  deleteReportsSuccess = () => {
    this.props.isRouting.open()
    this.props.setNotifications(['All reports successfully deleted'])
    this.props.routeTo('/')
  }
  deleteAccountSuccess = () => {
    this.props.isRouting.open()
    this.props.logout()
      .then(() => this.props.history.push('/account-deleted'))
  }

  componentDidMount() {
    getFetcher(`/api/account/${this.props.isReportCleanup ? "report" : "data"}-cleanup/verify/${this.props.match.params.token}`)
    // Promise.resolve({})
      .then((()=>this.setState({verified:true})))
      .catch((e)=>this.props.history.push('/error/deletionExpired'))
    getFetcher('/api/reports', {size: 1, page: 0, sort: 'last_Saved,desc'})
      .then(({totalElements}) => this.setState({totalReports: totalElements}))
  }

  resetPassword = () => {
    this.props.sendingResetPassword.open()
    this.props.resetPasswordDialog.open()
    postFetcher("/api/account/reset-password/init",this.props.user.email)
      .then(() => {
        this.props.sendingResetPassword.close()
      })
      .catch(() => {
        this.props.sendingResetPassword.close()
      })
  }

  render() {
    const {isReportCleanup, sendingResetPassword, resetPasswordDialog, form, isRouting, user, stripe: {customer}, match} = this.props
    const {totalReports,verified} = this.state
    if (totalReports === undefined || !verified) { return <LoadingUser/>}
    const subscription = normalizeSubscription(customer.subscriptions && customer.subscriptions.data[0])
    return <ConfirmDeletionPage className="content edit-profile">
      <Button.Link className="return-home-button" icon="arrow-left" to="/">Home</Button.Link>
      <div className="profile-header">
        <h1><Icon icon="warning"/> <span>Confirm {isReportCleanup ? 'data' : 'account'} deletion</span></h1>
      </div>
      {
        isReportCleanup ?
          <p>
            <strong>You are about to delete all reports in your Horos Cloud account.</strong> Please
            carefully review the details bellow and click on “Delete all reports” to proceed with the deletion.
          </p> :
          <p>
            <strong>You are about to delete your Horos Cloud account and all its data. </strong>
            Please carefully review the details bellow and click “Confirm deletion” to delete the account.
          </p>
      }
      <h3>Account details</h3>
      <div className="card account-card">
        <div className="user-avatar" style={this.getAvatarBackground()}/>
        <div className="account-details">
          <h4>{user.firstName} {user.lastName}&rsquo;s account</h4>
          <ul>
            <li>{user.email}</li>
            <li>Member since <Timer language="en" dateFormat="LL dd, yyyy" noHours
                                    time={new Date(customer.created * 1000)}/></li>
            <li>{
              subscription.status === 'active' ? 'Active Horos Cloud subscription' :
                subscription.status === 'trialing' ? 'Account on Horos Cloud Trial' :
                  'No Horos Cloud subscription'
            }</li>
            <li>{totalReports} reports on Horos Cloud</li>
          </ul>
          <span className="help-text"><strong>Once confirmed, this action is irreversible.</strong></span>
        </div>
        <div className="actions">
          <Form
            form={form}
            onSuccess={isReportCleanup ? this.deleteReportsSuccess : this.deleteAccountSuccess}
            onFailure={this.onFailure}
            preValidation={({password})=> ({success:{password,key:match.params.token}})}
            alwaysSave
            url={isReportCleanup ? '/api/account/report-cleanup/finish/' : '/api/account/data-cleanup/finish/'}
          >
            <TextInput
              form={form}
              type="password"
              label="Password:"
              path="password"
              autocomplete="off"
              placeholder="Enter password"
            />
            <a onClick={this.resetPassword} className="link forgot-pass">Forgot password?</a>
            <Button type="submit" isLoading={form.isLoading || isRouting.isOpen} alert icon="warning">
              {isReportCleanup ? 'Delete all reports' : 'Confirm deletion'}
            </Button>
          </Form>
        </div>
      </div>
      <Errors form={form}/>
      {subscription.status === 'active' && !isReportCleanup &&
      <InfoBox gray>
        <span>Your active Horos Cloud subscription will be canceled upon account deletion, meaning no more charges will be made to this account’s credit card unless you choose to reactivate it. Payments already made are not refundable.</span>
      </InfoBox>
      }
      {
        resetPasswordDialog.isOpen &&
          <Dialog
            title="Sending password reset email"
          >
            <Dialog.Content>
              {
                sendingResetPassword.isOpen ?
                  <LoadingEmail>
                    <Loading /> <span>Loading...</span>
                  </LoadingEmail> :
                  <div>
                    <strong>We've just sent you an email for defining a new password. </strong>
                    <span>Check your email and click the link shared there to redefine your password. If you do not wish to redefine your password, just ignore the email and nothing will be changed.</span>
                  </div>
              }
            </Dialog.Content>
            {!sendingResetPassword.isOpen &&
              <Dialog.Footer>
                <Button onClick={resetPasswordDialog.close}>Close</Button>
              </Dialog.Footer>
            }
          </Dialog>
      }
    </ConfirmDeletionPage>
  }

}



// WEBPACK FOOTER //
// ./src/javascripts/user/ConfirmDeleteAccount.jsx